import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'semantic-ui-react'

const FormTextArea = ({
  style, input, fluid, icon, placeholder, onChange, type, label, required, name, value
}) => (
  <Form.TextArea
    style={style}
    input={input}
    fluid={fluid}
    placeholder={placeholder}
    onChange={onChange}
    type={type}
    label={label}
    required={required}
    name={name}
    value={value}
  />
);

FormTextArea.propTypes = {
    style: PropTypes.object,
    input: PropTypes.string,
    fluid: PropTypes.bool,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    onChange: PropTypes.func,
};

export { FormTextArea };
